/**
 * @group Server
 * 
 * @summary
 * <blockquote>React Native stub for Request-scoped ResourceConfig management</blockquote>
 * 
 * @remarks
 * This is a React Native specific implementation that avoids importing Node.js
 * modules like `async_hooks`. It provides a no-op API compatible with the
 * server version so that mobile bundles do not include Node-only code.
 * 
 * Mobile should manage ResourceConfig via mobile-specific context (see
 * `apps/mobile/src/utils/MobileResourceManager.ts`).
 */

import type { ResourceConfig } from '../interfaces/ResourceConfig';
import type { RequestContextManagerInterface } from './RequestContextManagerInterface';

class RequestContextManagerNativeStub implements RequestContextManagerInterface {
  initialize(): void {
    // no-op on React Native
  }

  getStack(): ResourceConfig[] {
    // React Native does not use server request context
    return [];
  }

  push(_key: string, _config: ResourceConfig): void {
    // no-op on React Native
  }

  pop(_key: string): void {
    // no-op on React Native
  }

  clear(): void {
    // no-op on React Native
  }

  /** @internal */
  _getStorageInstance(): unknown {
    return undefined;
  }
}

export default new RequestContextManagerNativeStub();


